import { GetSplitFormDataActionTypes, GetSplitFormDataState, GET_SPLIT_FORM_DATA_REQUEST, GET_SPLIT_FORM_DATA_SUCCESS, GET_SPLIT_FORM_DATA_FAILURE } from './types';

const defaultState: GetSplitFormDataState = {
  isLoading: false,
  errorMessage: ""
};

export default function getSplitFormData(state = defaultState, action: GetSplitFormDataActionTypes): GetSplitFormDataState {
  switch (action.type) {
    case GET_SPLIT_FORM_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_SPLIT_FORM_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_SPLIT_FORM_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
